// src/pages/GalleryPage.js
import React from 'react';
import Footer from '../components/Footer/footer';
import FloatingNavbar from '../components/Navbar/floating_navbar';
import FullGallery from '../components/Gallery/full_gallery';


const GalleryPage = () => {
  return (
    <>
      <FloatingNavbar visibleItems={['language']}/>
      <FullGallery/>
      <Footer />
    </>
  );
};

export default GalleryPage;
